import React from "react";
import { DeleteConfirmConsts } from "./constants";
import InputField from "../../../../../reusable-components/TNInputField";
import { InputfieldTypes } from "../../../../../enums/InputFieldAttributesEnums";
import { Modal } from "antd";
import TNLoader from "../../../../../reusable-components/TNLoader";
import { CommonButtonTexts } from "../../../../../enums/ButtonAttributesEnums";
import { useQueryClient } from "@tanstack/react-query";
import { useFormContext } from "react-hook-form";
import QuarryDatabaseService from "../../../../../services/quarryDatabase.service";
import { QueryKeys } from "../../../../../constants/QueryKeys";

export interface DeleteMaterialModalProps {
  isOpen?: boolean;
  handleClose: () => void;
  submitActionCall: () => void;
  quarryId?: string;
  materialId?: string;
  subCategoryListLength?: number;
}

const DeleteMaterialModal = ({
  isOpen,
  handleClose,
  submitActionCall,
  quarryId,
  materialId,
  subCategoryListLength,
}: DeleteMaterialModalProps) => {
  const { reset, getValues, handleSubmit } = useFormContext();
  const queryClient = useQueryClient();
  const { DeleteQuarryMaterial } = QuarryDatabaseService();
  const { mutateAsync: deleteMaterial, isPending } = DeleteQuarryMaterial();

  const {
    TITLE,
    MODAL_WITH,
    MESSAGE,
    REASON_LABEL,
    REASON_PLACEHOLDER,
    REASON_NAME,
    DELETE_SUCCESS,
  } = DeleteConfirmConsts;

  const handleCancel = () => {
    reset();
    handleClose();
  };

  const handleSubmitAction = async () => {
    await deleteMaterial({
      quarryId: quarryId,
      materialId: materialId,
      notes: getValues(REASON_NAME),
    });
    subCategoryListLength > 1
      ? submitActionCall()
      : queryClient?.invalidateQueries([
          QueryKeys?.FETCH_QUARRY_MATERIAL_CATEGORY_LIST_KEY,
        ]);
    handleCancel();
  };

  return (
    <>
      <TNLoader isLoading={isPending} />
      <Modal
        title={TITLE}
        okText={CommonButtonTexts.CONFIRM}
        visible={isOpen}
        onCancel={handleCancel}
        onOk={handleSubmit(handleSubmitAction)}
        width={MODAL_WITH}
        loading={false}
        maskClosable={false}
        destroyOnClose={true}
      >
        <div>{MESSAGE}</div>
        <InputField
          type={InputfieldTypes.TEXT_AREA}
          name={REASON_NAME}
          label={REASON_LABEL}
          maxLength={500}
          textAreaRows={6}
          noResize
          requiredField
          placeholder={REASON_PLACEHOLDER}
        />
      </Modal>
    </>
  );
};

export default DeleteMaterialModal;
